import { Pronouns } from '@wix/ambassador-asa-assistant-properties-v1-assistant-properties/types';
import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export { Pronouns };
export let Trait = /*#__PURE__*/function (Trait) {
  Trait["FRIENDLY"] = "FRIENDLY";
  Trait["WARM"] = "WARM";
  Trait["POLITE"] = "POLITE";
  Trait["SUPPORTIVE"] = "SUPPORTIVE";
  Trait["PROFESSIONAL"] = "PROFESSIONAL";
  Trait["CONFIDENT"] = "CONFIDENT";
  Trait["CHATTY"] = "CHATTY";
  Trait["CONCISE"] = "CONCISE";
  Trait["CALM"] = "CALM";
  Trait["CHEERFUL"] = "CHEERFUL";
  Trait["PLAYFUL"] = "PLAYFUL";
  Trait["FORMAL"] = "FORMAL";
  Trait["RESOURCEFUL"] = "RESOURCEFUL";
  Trait["CASUAL"] = "CASUAL";
  return Trait;
}({});
export let AvatarVariant = /*#__PURE__*/function (AvatarVariant) {
  AvatarVariant["UNSELECTED"] = "unselected";
  AvatarVariant["BEAM"] = "beam";
  AvatarVariant["MARBLE"] = "marble";
  AvatarVariant["PIXEL"] = "pixel";
  AvatarVariant["SUNSET"] = "sunset";
  AvatarVariant["RING"] = "ring";
  return AvatarVariant;
}({});
export const DEFAULT_ASSISTANT_PROPERTIES = {
  name: 'Orion',
  personality: '',
  pronouns: Pronouns.OTHER,
  traits: [Trait.PROFESSIONAL, Trait.CONCISE, Trait.FRIENDLY],
  avatarVariant: AvatarVariant.UNSELECTED,
  imageUrl: 'https://static.wixstatic.com/media/8174c4_72b6d53dffe0438fb830a8ed458ce9f2~mv2.jpg'
};
export const isValidAssistantProperties = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['name', 'personality', 'pronouns', 'avatarVariant']);
  return ans;
};
//# sourceMappingURL=AssistantProperties.js.map